// extracted by mini-css-extract-plugin
export default {"productCardTitle":"components-ProductCardFlag-themes-GOP-styles__productCardTitle--E1FLI"};